import React, { useState, useEffect } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import NextActionItem from './components/NextActionItem';
import ProjectService from '../../service/project-service';
import { useStoreValue } from '../../store';
import '../../assets/components/NextActions.css';

const NextActions = () => {
    const projects = useStoreValue('projects');
    const [items, setItems] = useState([]);

    useEffect(() => {
        ProjectService.getCueSheetListAsync().then((data) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const futureItems = data
                .filter((o) => o.startDate && new Date(o.startDate) > today)
                .map((o) => {
                    const project = projects.find((p) => p.id === o.projectId);
                    return {
                        id: o.id,
                        projectId: o.projectId,
                        status: o.status,
                        title: `${project?.title ?? o.projectId} / ${o.label}`,
                        date: o.startDate,
                        within: Math.ceil((new Date(o.startDate) - today) / 86400000),
                    };
                });

            setItems(futureItems);
        });
    }, [projects]);

    return (
        <OverlayScrollbarsComponent element="div" className="appNextActions" options={{ scrollbars: { autoHide: 'never' } }} defer>
            <ul className="appNextActions__inner">
                {items.map((o) => <NextActionItem key={o.id} data={o} within={o.within}/>)}
            </ul>
        </OverlayScrollbarsComponent>
    );
};

export default NextActions;
